export default {
    global: {
        MESSAGE: {
            TIME: 3
        }
    },
    prod: {
    },
    dev: {
    }
}



// WEBPACK FOOTER //
// ./src/config/ui.js